import Layout1 from '@/layout/Layout1'

export default [{
  path: '/system',
  component: Layout1,
  children: [{
    path: 'mnuser/:id',
    component: () => import('@/components/system/maintenance/users/userEdit')
  }, {
    path: 'mnuser',
    component: () => import('@/components/system/maintenance/users/userList')
  }, {
    path: 'mnrole/:id',
    component: () => import('@/components/system/maintenance/roles/roleEdit')
  }, {
    path: 'mnrole',
    component: () => import('@/components/system/maintenance/roles/roleList')
  }, {
    path: 'mnannouncement/:id',
    component: () => import('@/components/system/maintenance/announcements/announcementEdit')
  }, {
    path: 'mnannouncement',
    component: () => import('@/components/system/maintenance/announcements/announcementList')
  }, {
    path: 'accountsettings',
    component: () => import('@/components/system/settings/AccountSettings')
  }, {
    path: 'mncurrency/:id',
    component: () => import('@/components/system/maintenance/currencies/currencyEdit')
  }, {
    path: 'mncurrency',
    component: () => import('@/components/system/maintenance/currencies/currencyList')
  }, {
    path: 'currencybasesetup/:id',
    component: () => import('@/components/system/maintenance/currencybasesetups/currencybasesetupEdit')
  }, {
    path: 'currencybasesetup',
    component: () => import('@/components/system/maintenance/currencybasesetups/currencybasesetupList')
  }, {
    path: 'userregapprovalrouting/:id',
    component: () => import('@/components/medialibrary/transaction/userregapproval/userregapprovalEdit')
  }, {
    path: 'userregapproval',
    component: () => import('@/components/medialibrary/transaction/userregapproval/userregapprovalList')
  }, {
    path: 'settings',
    component: () => import('@/components/system/maintenance/settings/settingsEdit')
  }]
}]
